export default __webpack_public_path__ + "static/media/Vector-9.a4011ebe.svg";